const OPPORTUNITY_SERVICE_REQUEST_LIMIT = 50

/**
 * How long the HTTP client waits for a response before aborting the request.
 * Turns an indefinitely hanging (high-latency) call into a fast, retryable
 * failure. Applies to every request (all envs), so it is kept generous enough
 * not to abort legitimately slow calls while still bounding retry latency.
 * See PX-3333.
 */
const REQUEST_TIMEOUT_MS = 20_000

export { OPPORTUNITY_SERVICE_REQUEST_LIMIT, REQUEST_TIMEOUT_MS }
